import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { Globe2, LockKeyhole } from 'lucide-react';
import commumityImage from '../../assets/images/community.png';
import NamedLink from '../NamedLink/NamedLink';
import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';

import css from './CommunityCard.module.css';
import { FormattedMessage } from '../../util/reactIntl';

// DiscoverGroupsCommunityPage || CircleCommunityPage
// spaceListDataV2
const CommunityCard = props => {
  const {
    className,
    sellerUserCard,
    data,
    buttonTextId = '',
    searchGroupsData = false,
    showMembershipActions = false,
    isMember = false,
    isJoinPending = false,
    joinButtonLabel = 'Ask to Join',
    joinPendingLabel = 'Pending',
    onJoin,
    onViewGroup,
  } = props;
  const {
    cover_image_url,
    slug = "TEST",
    id = "11",
    name,
    space_members_count = 0,
    thumbnail_image_url,
    is_private,
    is_secret,
    is_hidden_from_non_members,
    visibility,
    space_type,
    type,
  } = data;
  const { records = [] } = searchGroupsData || {};
  const count = space_members_count || 0;
  const visibilityText = String(visibility || space_type || type || '').toLowerCase();
  const isPrivateGroup = Boolean(
    is_private ||
    is_secret ||
    is_hidden_from_non_members ||
    visibilityText.includes('private') ||
    visibilityText.includes('secret')
  );

  // Detect if mobile device
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  // Use thumbnail on mobile, cover image on desktop
  const imageUrl = thumbnail_image_url ? thumbnail_image_url : (cover_image_url || commumityImage);
  const viewGroupContent = (
    <>
      <ProfileIconCard type="message" />
      <FormattedMessage id={buttonTextId || "CircleSearchPage.groupCardDiscussionButton"} />
    </>
  );

  return (
    <div className={className} key={id}>
      <div
        className={classNames(css.communityWrapper, sellerUserCard && css.sellerCommunityWrapper)}
      >
        <div className={css.communityImage}>
          <img
            src={imageUrl}
            className={sellerUserCard ? css.sellerImage : css.mainImage}
          />
          {showMembershipActions && isMember ? (
            <div className={css.memberPill}>I'M A MEMBER</div>
          ) : null}
          {/* <div
                        className={classNames(css.followersDetail, sellerUserCard && css.sellerfollowersDetail)}
                    >

                    </div> */}
          {/* <div className={css.profileIcon}>
                        <img src={profileIcon} />
                    </div> */}
        </div>
        <div className={css.commumityBody}>
          <div className={css.communityMeta}>
            <div className={css.communityProfile}>
              <ProfileIconCard type="follower" />
              <FormattedMessage id='CircleSearchPage.groupCardMembers' values={{ memberCount: count || 0 }} />
            </div>
            <div className={css.privacyIndicator}>
              {isPrivateGroup ? <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.77611 2.59748e-09C6.77242 -3.65673e-05 7.72995 0.386079 8.44752 1.07722C9.16516 1.76837 9.58691 2.71074 9.62429 3.70634L9.62681 3.85074H10.2686C10.5925 3.85064 10.9044 3.97294 11.1418 4.19313C11.3793 4.41333 11.5247 4.71513 11.549 5.03805L11.5522 5.13432V11.5522C11.5523 11.8761 11.43 12.188 11.2098 12.4254C10.9896 12.6629 10.6878 12.8083 10.3649 12.8326L10.2686 12.8358H1.28358C0.959749 12.8359 0.647843 12.7136 0.410396 12.4934C0.172949 12.2732 0.0274961 11.9714 0.00321308 11.6485L5.88486e-08 11.5522V5.13432C-9.79411e-05 4.81048 0.122206 4.49859 0.342398 4.26113C0.56259 4.02368 0.864395 3.87824 1.18731 3.85395L1.28358 3.85074H1.92537C1.92537 2.82946 2.33107 1.85001 3.05323 1.12785C3.77538 0.405702 4.75483 2.59748e-09 5.77611 2.59748e-09ZM10.2686 5.13432H1.28358V11.5522H10.2686V5.13432ZM5.77611 6.41789C6.04988 6.41799 6.31644 6.50561 6.53694 6.66797C6.75737 6.83033 6.92012 7.05894 7.00139 7.32039C7.08266 7.58177 7.07825 7.8624 6.98872 8.12112C6.89926 8.37984 6.72937 8.60321 6.5039 8.75847L6.41787 8.81307V9.62682C6.41773 9.79041 6.35508 9.94777 6.2428 10.0667C6.13052 10.1856 5.97701 10.2572 5.8137 10.2668C5.65042 10.2764 5.48963 10.2233 5.36419 10.1183C5.23875 10.0133 5.15813 9.8644 5.13881 9.70193L5.13432 9.62682V8.81307C4.88963 8.67174 4.6984 8.45369 4.59028 8.19266C4.48216 7.93163 4.46319 7.64218 4.53632 7.36925C4.60946 7.09632 4.77059 6.85517 4.99475 6.68316C5.21891 6.51115 5.49356 6.41791 5.77611 6.41789ZM5.77611 1.28358C5.09526 1.28358 4.44229 1.55405 3.96085 2.03548C3.47942 2.51692 3.20895 3.16989 3.20895 3.85074H8.34329C8.34329 3.16989 8.07281 2.51692 7.59135 2.03548C7.10996 1.55405 6.45693 1.28358 5.77611 1.28358Z" fill="#8F8C94" />
              </svg>
                : <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.3001 4.56888V2.86888C2.29955 2.3168 2.50051 1.7835 2.86527 1.36908C3.23003 0.954653 3.73351 0.687596 4.28119 0.618044C4.82887 0.548484 5.38311 0.681205 5.8399 0.991301C6.2967 1.30139 6.62454 1.76752 6.76206 2.30222M4.56676 7.40222C4.71705 7.40222 4.86119 7.34254 4.96746 7.23622C5.07373 7.12998 5.13343 6.98582 5.13343 6.83556C5.13343 6.68526 5.07373 6.54113 4.96746 6.43486C4.86119 6.32859 4.71705 6.26888 4.56676 6.26888C4.41647 6.26888 4.27234 6.32859 4.16607 6.43486C4.0598 6.54113 4.0001 6.68526 4.0001 6.83556C4.0001 6.98582 4.0598 7.12998 4.16607 7.23622C4.27234 7.34254 4.41647 7.40222 4.56676 7.40222ZM4.56676 7.40222V9.10222M1.50676 4.56888H7.62678C8.12542 4.56888 8.53342 4.97688 8.53342 5.47556V9.44222C8.53342 10.1902 7.92142 10.8022 7.17342 10.8022H1.9601C1.2121 10.8022 0.600098 10.1902 0.600098 9.44222V5.47556C0.600098 4.97688 1.0081 4.56888 1.50676 4.56888Z" stroke="#8F8C94" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" fill="none" />
                </svg>
              }
              {isPrivateGroup ? 'Private Group' : 'Public Group'}
            </div>
          </div>
          <div className={css.commumityTitle}>{name}</div>
          <div className={showMembershipActions && !isMember ? css.communityActions : css.viewCommunityButton}>
            {onViewGroup ? (
              <button
                type="button"
                className={css.viewGroupButton}
                onClick={() => onViewGroup({ id, slug })}
              >
                {viewGroupContent}
              </button>
            ) : (
              <NamedLink name="DiscoverGroupsCommunityPage" params={{ id, slug }}>
                {viewGroupContent}
              </NamedLink>
            )}
            {showMembershipActions && !isMember ? (
              <button
                type="button"
                className={classNames(
                  css.joinButton,
                  isPrivateGroup ? css.privateJoinButton : css.publicJoinButton
                )}
                onClick={() => onJoin?.(id)}
                disabled={isJoinPending}
              >
                {isJoinPending ? joinPendingLabel : joinButtonLabel}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};


CommunityCard.defaultProps = {
  className: null,
};

CommunityCard.propTypes = {
  className: string,
};

export default CommunityCard;
